import React from 'react';
import './SessionFormatScreen.css';

const SessionFormatScreen = ({ onNext, onBack, onDataUpdate, data }) => {
  return (
    <div className="session-format-screen">
      <h1>Session Format</h1>
      <p>Coming soon...</p>
      <div className="form-actions">
        <button onClick={onBack} className="back-button">
          Back
        </button>
        <button onClick={onNext} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default SessionFormatScreen; 